'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isIOS = isIOS;
function isIOS() {
  var userAgent = window.navigator.userAgent;
  return Boolean(userAgent.match(/iPad|iPhone|iPod/)) && !window.MSStream;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/util/isIOS.js
// module id = 1151
// module chunks = 2 3